import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  searchPlatformViewAccessControl,
  searchPlatformModifyAccessControl,
} from '../access-control/searchPlatformAccess.configuration'

const SearchPlatformSearchResultsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SearchPlatformSearchResultsPage" */
      '../pages/SearchPlatformSearchResultsPage'
    )
)

const SearchPlatformCreatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "SearchPlatformCreatePage" */
      '../pages/SearchPlatformCreatePage'
    )
)

const SearchPlatformEditPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SearchPlatformEditPage" */
      '../pages/SearchPlatformEditPage'
    )
)

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const searchPlatformRouter = (
  <DomainRoute route="search-platform" accessControl={searchPlatformViewAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="search-platform-create"
        component={SearchPlatformCreatePage}
        accessControl={searchPlatformModifyAccessControl}
      />
      <DomainRoute
        exact
        route="search-platform-edit"
        component={SearchPlatformEditPage}
        accessControl={searchPlatformModifyAccessControl}
      />
      <DomainRoute
        exact
        route="search-platform-search-results"
        component={SearchPlatformSearchResultsPage}
      />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
